import { render, staticRenderFns } from "./activeLuckyStudentLists.vue?vue&type=template&id=071e9344&"
import script from "./activeLuckyStudentLists.vue?vue&type=script&lang=js&"
export * from "./activeLuckyStudentLists.vue?vue&type=script&lang=js&"
import style0 from "./activeLuckyStudentLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports